module.exports = __webpack_public_path__ + "media/fonts/lineto-circular-book-fde5381f8e94fb4ad9db3709cd7fa1c7.svg";